import { ref, nextTick, reactive, computed } from 'vue'
import { message } from 'ant-design-vue'
import { useUserInfoStore } from '@/stores/user-info'
import { accountApi } from '@/api/account'
import { useRouter } from 'vue-router'
import { removeToken } from '@/utils/token/index'

export const useHooks = (emit) => {
    const userStore = useUserInfoStore()
    const router = useRouter()

    const showIpt = ref(false)
    const titleInput = ref()
    const password = ref('******')
    const info = computed(() => userStore.userInfo)

    const modalType = ref('')
    const visibleModal = ref(false)
    const editData = reactive({
        name: '',
        tel: '',
        email: '',
        id: info?.value?.id
    })
    const save = async () => {
        if (info.value.name == '') {
            message.error('名称不能为空')
            return
        }
        const params = {
            id: info.value.id,
            name: info.value.name
        }
        showIpt.value = false
        const res = await accountApi.updateCustomerUser(params)

        userStore.initUserInfo()

        console.log('updateCustomerUser', res)
    }
    const refreshList = () => {
        userStore.initUserInfo()
        console.log('refreshList')
    }
    const toggleInput = () => {
        showIpt.value = true
        nextTick(() => titleInput.value.focus())
    }
    const toggleInfo = (type: string) => {
        visibleModal.value = true
        if (type == 'phone') {
            editData.tel = info.value.mobile
            modalType.value = 'phone'
        }
        if (type == 'email') {
            editData.email = info.value.email
            modalType.value = 'email'
        }
        if (type == 'name') {
            editData.name = info.value.name
            modalType.value = 'name'
        }
        emit('hide')
    }
    const psdModal = ref<boolean>(false)
    const showPsdModal = (bool: boolean) => {
        psdModal.value = bool
    }

    const handleClose = () => {
        userStore.setShowUserCenter(false)
    }
    // 推出按钮点击事件
    const handleLogout = async () => {
        try {
            await accountApi.loginOut()
            message.success('已退出登录')
            removeToken()
            userStore.clearUserInfo()
            emit('update:modelValue', false)
            router.push('/')
        } catch (e) {
            console.warn('handleLogout', e)
        }
    }

    return {
        showIpt,
        titleInput,
        password,
        info,
        visibleModal,
        editData,
        psdModal,
        modalType,
        save,
        refreshList,
        toggleInput,
        toggleInfo,
        showPsdModal,
        handleClose,
        handleLogout
    }
}
